var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgblock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#imgblock_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3 19.626h15.4c1.722 0 2.592-.879 2.592-2.566V6.284c0-1.696-.87-2.575-2.593-2.575H4.301c-1.714 0-2.593.87-2.593 2.575V17.06c0 1.696.879 2.566 2.593 2.566zM2.799 6.336c0-1.01.536-1.537 1.52-1.537h15.364c.966 0 1.52.527 1.52 1.538v10.09l-4.922-4.57c-.422-.352-.852-.563-1.362-.563-.51 0-.923.176-1.345.554l-3.999 3.568-1.652-1.512c-.37-.342-.756-.518-1.195-.518-.414 0-.765.176-1.134.5l-2.795 2.576V6.337zm5.37 5.441a2.076 2.076 0 002.065-2.074A2.082 2.082 0 008.168 7.63c-1.143 0-2.074.94-2.074 2.074 0 1.143.931 2.074 2.074 2.074z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "imgblock_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default __webpack_public_path__ + "static/media/imgblock.acbe3584.svg";
export { SvgImgblock as ReactComponent };